// extracted by mini-css-extract-plugin
export default {"spinner":"Root_spinner__wvjD0"};